/** @format */

import {Box, Typography} from '@mui/material';

import {AreaChartMultiDataType, TooltipDataList} from '../index';
import {classes, StyledBox} from '../styles';

type payloadType = {
  payload: AreaChartMultiDataType;
};

interface CustomTooltipProps {
  active?: boolean;
  payload?: payloadType[];
  tooltipData: TooltipDataList;
}

const CustomSensorsTooltip = ({active, payload, tooltipData}: CustomTooltipProps) => {
  if (active && payload && payload.length) {
    const pointName = payload[0].payload.name;
    const {dateDisplay, tooltipRows} = tooltipData[pointName];

    return (
      <StyledBox>
        <Box className={classes.content}>
          <Typography className={classes.date}>{dateDisplay}</Typography>
        </Box>

        <Box className={classes.divider} />

        <Box className={classes.content}>
          <Box className={classes.list}>
            {tooltipRows.map(row => (
              <Box key={row.label} className={classes.listItem}>
                <Typography className={classes.amount}>{row.label}</Typography>
                <Typography className={classes.amount}>{row.value}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </StyledBox>
    );
  }

  return null;
};

export default CustomSensorsTooltip;
